import React from 'react';
import classnames from 'classnames';

import classes from './StepContainer.scss';

type containerType = {
    className?: string;
    background?: string;
};

export const StepContainer: React.FC<React.PropsWithChildren<containerType>> = ({
    className,
    children,
    background,
}) => {
    const backgroundClass = background || 'white';

    return <div className={classnames(classes.stepContainer, classes[backgroundClass], className)}>{children}</div>;
};
